export default __webpack_public_path__ + "4b82ba5fc809c3b3fa567fd268721d8e.jpg";